import React from 'react'
import './Home.css'
import { Link } from "react-router-dom"
import AppIcon from "@material-ui/icons/Apps"
import { Avatar } from "@material-ui/core"
import Search from './Search'
function Home() {
    return (
        <div className="home">
            <div className="home_header">
                <div className="home_headerLeft">
                    
                </div>
                <div className="home_headerRight">
                    <Link to="/">Gmail</Link>
                    <Link to="/">Images</Link>
                    <AppIcon />
                    <Avatar />
                </div>
            </div>
            <div className="home_body">
                <img src="https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_272x92dp.png" alt="Google-Logo"/>
                <div className="home_inputContainer">
                    <Search />
                </div>
            </div>
        </div>
    )
}

export default Home
